import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PROFILE_ELIGIBILITY_ALIVE } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetProfileEligibilityAliveResult } from '../types/getProfileEligibilityAlive.types';

export const TAG_PE_ALIVE = 'PEAlive';

export const getProfileEligibilityAlive = (builder: BuilderType) =>
  builder.query<GetProfileEligibilityAliveResult, void>({
    providesTags: [TAG_PE_ALIVE],
    query: () => ({
      data: {},
      method: 'POST',
      url: GET_PROFILE_ELIGIBILITY_ALIVE,
    }),
    transformResponse: (response: GenericApiResponse<GetProfileEligibilityAliveResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
